import { atom } from "jotai";

import { BookingWizardDataAtom } from "../../stores";

export const DurationSelectorAtom = atom<number | null>((get) => {
  const bookingWizardData = get(BookingWizardDataAtom);
  if (bookingWizardData?.type !== "DurationBooking") {
    return null;
  }
  const durationMins = bookingWizardData?.durationMins;
  return durationMins ?? null;
});
